<highcharts-chart
  [Highcharts]="highcharts"
  [options]="solidGaugeChartOptions"
  style="width: 100%; height: 160px; display: block; "
>
</highcharts-chart>
